export const mergeClassNames = (
  ...classNames: Array<string | null | undefined | false>
) => classNames.filter(Boolean).join(" ");

export const alignmentToClassName = (alignment?: "left" | "center" | "right") => {
  switch (alignment) {
    case "center":
      return "text-center";
    case "right":
      return "text-right";
    case "left":
    default:
      return "text-left";
  }
};